import type { ReactNode } from 'react';

import { HotelImagesContext } from './contexts/HotelImagesContext';
import useHotelImagesStore from './stores/useHotelImagesStore';

import type { Props } from './stores/useHotelImagesStore';

import { withUBFFContext } from '@shared/data-access-frontend/contexts/ubff-context';

const HotelImagesProvider = ({
  children,
  currency,
  gallery,
  hotelId,
  imageCount,
  locale,
  market,
  reviewImages,
  translate,
  uBFFGateway,
}: {
  children: ReactNode;
} & Props) => {
  const store = useHotelImagesStore({
    hotelId,
    locale,
    market,
    currency,
    imageCount,
    reviewImages,
    gallery,
    uBFFGateway,
    translate,
  });

  return (
    <HotelImagesContext.Provider value={store}>
      {children}
    </HotelImagesContext.Provider>
  );
};

export default withUBFFContext(HotelImagesProvider);
